import { createAsyncThunk } from "@reduxjs/toolkit";
import { adminAPI } from "../api";
import { toast } from "react-toastify";

export const patchUserStatus = createAsyncThunk(
  "admin/patchUserStatus",
  async (data: any, { rejectWithValue }) => {
    try {
      const res = await adminAPI.patchUserStatus(data);
      return res.data;
    } catch (error: any) {
      if (error?.response?.data?.title) {
        toast.error(error.response.data.title);
      } else if (error?.response?.data?.detail) {
        toast.error(error.response.data.detail);
      } else {
        toast.error("Не удалось верифицировать пользователя.");
      }
      return rejectWithValue(error?.response?.data?.title || error?.response?.data?.message || 'Error');
    }
  }
);
